import React from 'react';
import WeightChart from './Charts/WeightChart';
import WaterChart from './Charts/WaterChart';
import SleepChart from './Charts/SleepChart';
import StepsChart from './Charts/StepsChart';

const Statistics = ({ profileId, selectedDate, eventTypeId }) => {
  return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 px-4 py-6 w-full">
      <WaterChart profileId={profileId} selectedDate={selectedDate} eventTypeId={eventTypeId} />
      <StepsChart profileId={profileId} selectedDate={selectedDate} eventTypeId={eventTypeId} />
      <SleepChart profileId={profileId} selectedDate={selectedDate} eventTypeId={eventTypeId} />
      <WeightChart profileId={profileId} selectedDate={selectedDate} />
    </div>
  );
};

export default Statistics;
